import React from 'react';

import {
  AUFlag,
  ChinaFlag,
  GreeceFlag,
  HongKongFlag,
  IndiaFlag,
  ItalyFlag,
  LKFlag,
  PhFlag,
  SAFlag,
  VnFlag,
} from '../../../icons';
import { IntlMessages } from '../../../helper/langHelper';

export const languageOptions = [
  {
    value: 'en-US',
    label: <IntlMessages id="language.english" defaultMessage="English" />,
    icon: <AUFlag />,
  },
  {
    value: 'hi-IN',
    label: <IntlMessages id="language.hindi" defaultMessage="Hindi" />,
    icon: <IndiaFlag />,
  },
  {
    value: 'zh-CN',
    label: <IntlMessages id="language.mandarin" defaultMessage="Mandarin" />,
    icon: <ChinaFlag />,
  },
  {
    value: 'vi-VN',
    label: <IntlMessages id="language.vietnamese" defaultMessage="Vietnamese" />,
    icon: <VnFlag />,
  },
  {
    value: 'el-GR',
    label: <IntlMessages id="language.greek" defaultMessage="Greek" />,
    icon: <GreeceFlag />,
  },
  {
    value: 'pa-IN',
    label: <IntlMessages id="language.punjabi" defaultMessage="Punjabi" />,
    icon: <IndiaFlag />,
  },
  {
    value: 'it-IT',
    label: <IntlMessages id="language.italian" defaultMessage="Italian" />,
    icon: <ItalyFlag />,
  },
  {
    value: 'ar-SA',
    label: <IntlMessages id="language.arabic" defaultMessage="Arabic" />,
    icon: <SAFlag />,
  },
  {
    value: 'zh-HK',
    label: <IntlMessages id="language.cantonese" defaultMessage="Cantonese" />,
    icon: <HongKongFlag />,
  },
  {
    value: 'tl-PH',
    label: <IntlMessages id="language.filipino" defaultMessage="Filipino / Tagalog" />,
    icon: <PhFlag />,
  },
  {
    value: 'si-LK',
    label: <IntlMessages id="language.sinhalese" defaultMessage="Sinhalese" />,
    icon: <LKFlag />,
  },
];

export const getLanguageLabel = (value) => {
  const language = languageOptions.find((lang) => lang.value === value);
  return language ? language.label : 'Unknown';
};

// Frequently Asked Questions
export const FAQ_QUESTIONS = [
  'How to develop a duplex?',
  'How can I subdivide my property?',
  'What are the zoning requirements for construction?',
  'How do I obtain a building permit?',
  'What is the process for property development approval?',
];
